module.exports = __webpack_public_path__ + "static/media/edit.302f160d.svg";